import ajax from "@/utils/ajax.js";

export default {
    async getNetPayOrderAsync(listNo) {
        const r = await ajax.get(
            `/payment/GetNetPayOrderAsync?listNo=${listNo}`
        );
        return r.result;
    },
    async jsApiPayAsync(input) {
        const r = await ajax.post(`/payment/JsApiPayAsync`, input);
        return r.result;
    }
};
